import bullet from '../images/bullet.png'

export const listStyle = {
  listStyleImage: `url(${bullet})`,
  paddingTop: 15,
  paddingBottom: 15
}

export function getSectionTotalKey (sectionNumber) {
  return 'sectionTotal' + sectionNumber
}

export function getAggregateTotalKey (id) {
  return 'aggregate' + id
}



// WEBPACK FOOTER //
// ./src/components/sections/section.js